import { FC, useEffect, useState } from 'react'
import { ThreeDImageContentItem } from '@obeta/data/lib/hooks/useArticleGalleryContent'
import { useOxomiIntegration } from '@obeta/data/lib/hooks/useOxomiIntegration'
import { waitForField, waitForResolve } from '@obeta/utils/lib/waitFor'
import { OxomiGlobal } from '@obeta/models/lib/models/Oxomi'
import CircularProgress from '@mui/material/CircularProgress'
import styles from './ThreeDImageContainer.module.scss'
import './ThreeDImageDownloadDialogOverride.scss'

export const THREE_D_VIEW_ROOT_ID = 'threeDViewContainer'

type ThreeDImageContainerProps = {
  activeItem: ThreeDImageContentItem
}

export const ThreeDImageContainer: FC<ThreeDImageContainerProps> = ({ activeItem }) => {
  const [isLoaded, updateIsLoaded] = useState(false)
  useOxomiIntegration()

  useEffect(() => {
    const show3DImage = async () => {
      updateIsLoaded(false)

      try {
        if (!window?.oxomi.isInitialized()) {
          const oxomi = await waitForField<OxomiGlobal>({ field: 'oxomi' })
          await waitForResolve({ callback: oxomi.isInitialized })
        }

        const oxomiInstance = window?.oxomi

        if (oxomiInstance) {
          await oxomiInstance.product3dViewer({
            target: `#${THREE_D_VIEW_ROOT_ID}`,
            itemNumber: activeItem.itemNumber,
            supplierNumber: activeItem.supplierNumber,
          })
        }
      } finally {
        updateIsLoaded(true)
      }
    }

    show3DImage()
  }, [activeItem.itemNumber, activeItem.supplierNumber])

  return (
    <div id={THREE_D_VIEW_ROOT_ID} className={styles.threeDViewContainer}>
      {!isLoaded && <CircularProgress />}
    </div>
  )
}
